import React from 'react'
import { Grid, GridCell, Text, View } from 'oio-react'
import pluralize from 'pluralize'
import PropTypes from 'prop-types'
import { InitiativeDiscussionIcon, ViewGlyph12Icon } from 'assets/icons'
import highlightStringUsingRangeIndeces from './highlightStringUsingRangeIndeces'

const SearchListItemRow = ({
   dateAdded,
   label,
   matches,
   numThreadMessages,
   numViews,
   summary,
   title
}) => {
   const nameHighlights = matches.filter(m => m.path === 'name')
   const summaryHighlights = matches.filter(m => m.path === 'description.summary')
   const tagMatches = matches.filter(m => m.path === 'tags')
   const nameHighlightedHtml = highlightStringUsingRangeIndeces(title, nameHighlights)
   const summaryHighlightedHtml = highlightStringUsingRangeIndeces(summary, summaryHighlights)

   return (
      <View
         display="flex"
         padding="20px 0px"
         borderTop="1px solid #eee">
         <Grid columns="1[a-b] 6[c-f]" spacing="0px">
            <GridCell colspan="1[a-b] 2[c-f]">
               <View paddingRight="20px">
                  <Text size="2.5" color="#222" weight="medium">
                     <div dangerouslySetInnerHTML={{ __html: nameHighlightedHtml }} />
                  </Text>
                  <View
                     marginTop="2px"
                     display="none[a] block[b-f]">
                     <Text size="2.5" color="#888">
                        {label}
                     </Text>
                  </View>
               </View>
            </GridCell>
            <GridCell colspan="1[a-b] 4[c-f]">
               <View
                  height="100%"
                  minHeight="30px"
                  borderLeft="1px solid #eee[c-f]"
                  paddingTop="10px[a-b]"
                  paddingLeft="20px[c-f]">
                  {summaryHighlightedHtml && (
                     <View
                        marginBottom="5px"
                        maxHeight="100px"
                        style={{ overflow: 'hidden' }}>
                        <Text
                           size="2.5"
                           lineHeight="140%"
                           color="#777"
                           style={{ display: 'inline-block' }}>
                           <div dangerouslySetInnerHTML={{ __html: summaryHighlightedHtml }} />
                        </Text>
                     </View>
                  )}
                  {summaryHighlights.length === 0 && summary && (
                     <View
                        marginBottom="5px"
                        maxHeight="100px"
                        style={{ overflow: 'hidden' }}>
                        <Text
                           size="2.5"
                           lineHeight="140%"
                           color="#777"
                           style={{ display: 'inline-block' }}>
                           <div dangerouslySetInnerHTML={{ __html: summary }} />
                        </Text>
                     </View>
                  )}
                  {tagMatches.length > 0 && (
                     <View marginBottom="5px">
                        <Text size="2.5" color="#555">
                           Tagged with:
                           {tagMatches.map(match => (
                              <View
                                 key={match.value}
                                 display="inline-flex"
                                 alignItems="center"
                                 borderRadius="12px"
                                 padding="1px 6px"
                                 backgroundColor="#e3f3fa"
                                 marginLeft="5px">
                                 <Text size="1.5" color="#404e66">{match.value}</Text>
                              </View>
                           ))}
                        </Text>
                     </View>
                  )}
                  <View
                     display="flex"
                     alignItems="center"
                     flex="0 0 auto">
                     <View marginRight="15px">
                        <Text size="1.5" color="#aaa" style={{ float: 'left', display: 'inline-block' }}>
                           {dateAdded}
                        </Text>
                     </View>
                     {numThreadMessages > 0 && (
                        <View display="none[a] flex[b-f]" alignItems="center" marginRight="15px">
                           <View marginRight="5px">
                              <InitiativeDiscussionIcon
                                 width="12px"
                                 height="12px"
                                 color="#aaa"
                              />
                           </View>
                           <Text size="1.5" color="#aaa">
                              {`${pluralize('Replies', numThreadMessages, true)} `}
                           </Text>
                        </View>
                     )}
                     {numViews > 0 && (
                        <View display="none[a] flex[b-f]" alignItems="center">
                           <View marginRight="5px">
                              <ViewGlyph12Icon
                                 width="12px"
                                 height="12px"
                                 color="#aaa"
                              />
                           </View>
                           <Text size="1.5" color="#aaa">
                              {pluralize('Views', numViews, true)}
                           </Text>
                        </View>
                     )}
                  </View>
               </View>
            </GridCell>
         </Grid>
      </View>
   )
}

SearchListItemRow.propTypes = {
   dateAdded: PropTypes.string.isRequired,
   label: PropTypes.string.isRequired,
   matches: PropTypes.array.isRequired,
   numThreadMessages: PropTypes.number.isRequired,
   numViews: PropTypes.number.isRequired,
   summary: PropTypes.string.isRequired,
   title: PropTypes.string.isRequired
}

export default SearchListItemRow
